const LANDING_IMAGES_ROOT = '/webapp-landing-v2';
const ANDROID_SEGMENT = '/android/';

/**
 * Путь к картинке лендинга (`/webapp-landing-v2/...`).
 * Обычный домен — без изменений.
 * Альтдомен — android → `.../android/altdomain/...`, иначе → `.../ios/altdomain/...`.
 */
export function getLandingImagePath(imgSrc: string, altDomain: boolean) {
    if (!altDomain) {
        return imgSrc;
    }

    if (imgSrc.startsWith(`${LANDING_IMAGES_ROOT}${ANDROID_SEGMENT}`)) {
        return imgSrc.replace(
            `${LANDING_IMAGES_ROOT}${ANDROID_SEGMENT}`,
            `${LANDING_IMAGES_ROOT}${ANDROID_SEGMENT}altdomain/`,
        );
    }

    return imgSrc.replace(`${LANDING_IMAGES_ROOT}/`, `${LANDING_IMAGES_ROOT}/ios/altdomain/`);
}
